import {action, makeObservable, observable, runInAction} from "mobx";

import {AdminApi} from "../../../api/api";
import {CategoryGroupListItemOutput} from "../../../api/values/category-group-list-item-output";
import {Stores} from "../../../stores";
import {Permission} from "../../../stores/authentication-store";
import {PageStoreConstructorOptions} from "../../../utils/page-store";

export class CategoryGroupPageStore {
    @observable
    public mediaId: string = "";
    @observable
    public categoryGroups: CategoryGroupListItemOutput[] = [];
    private adminApi: AdminApi;
    private stores: Stores;
    constructor(options: PageStoreConstructorOptions) {
        makeObservable(this);

        this.adminApi = options.adminApi;
        this.stores = options.stores;
    }

    @observable
    public async initialize({query}: {query: {mediaId: string}}) {
        this.stores.authenticationStore.checkAnyPermissionExists(
            Permission.MANAGE_SYSTEM,
            Permission.MANAGE_MEDIA,
        );
        this.setMediaId(query.mediaId || "");
        await this.load();
    }

    @action
    public setMediaId(mediaId: string) {
        this.mediaId = mediaId;
    }

    public async load() {
        try {
            const result = await this.adminApi.getCategoryGroups({mediaId: this.mediaId});
            runInAction(() => {
                this.categoryGroups = result.categoryGroups;
            });
        } catch (error) {
            console.error(error);
        }
    }
}
